import React from "react";
import { Menu } from "@headlessui/react";
import cx from "classnames";
import shevronDown from "img/shevron-down.svg";

function MenuToggle({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className="flex-1">{children}</div>

      <div className="w-[1.4rem] h-[1.4rem] border-0 flex items-center justify-center shrink-0">
        <img src={shevronDown} alt="icon" />
      </div>
    </>
  );
}

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export function MoreDropdown(props: Props) {
  return (
    <div className={cx("tailwind relative flex", props.className)}>
      <Menu>
        <Menu.Button className="inline-flex rounded-sm items-center gap-2 cursor-pointer self-stretch text-white opacity-20">
          <MenuToggle>More</MenuToggle>
        </Menu.Button>

        <Menu.Items as="div" className="menu-items">
          {React.Children.map(props.children, (child, i) => {
            if (!child || !React.isValidElement(child)) {
              return null;
            }

            return (
              <Menu.Item>
                {({ close }) =>
                  React.cloneElement(child as any, {
                    className: cx([child.props.className, "menu-item"]),
                    onClick: close,
                  })
                }
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Menu>
    </div>
  );
}
